module.exports = __webpack_public_path__ + "static/media/analytics-active.981f4514.svg";